var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKronicle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.65789C0 1.91384 1.41384 0.5 3.15789 0.5H16.8421C18.5862 0.5 20 1.91384 20 3.65789V17.3421C20 19.0862 18.5862 20.5 16.8421 20.5H3.15789C1.41384 20.5 0 19.0862 0 17.3421V3.65789Z",
    fill: "url(#paint0_linear_3084_25392)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62379 14.5V7.32297H6.1412V10.4874H6.23581L8.81857 7.32297H10.6374L7.974 10.5365L10.6689 14.5H8.85361L6.88764 11.5493L6.1412 12.4604V14.5H4.62379ZM14.508 7.32297V14.5H12.9906V8.76328H12.9485L11.3049 9.79358V8.44788L13.0817 7.32297H14.508Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3084_25392",
    x1: -4.13583e-7,
    y1: -0.214285,
    x2: 20,
    y2: 20.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4778F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3052A6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKronicle);
export default __webpack_public_path__ + "static/media/kronicle.3f8131fa13b5b003a412b837208933ed.svg";
export { ForwardRef as ReactComponent };